import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { RouteService } from 'src/app/services/route.service';
import { RouteState } from 'src/app/_models/state/routeState';
import { UserService } from 'src/app/services/user.service';
import { SubscriptionLevel } from 'src/app/auth/models/user';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { Common } from '@trimblemaps/trimblemaps-js';
import { downloadCSV } from '../../_helpers/export-csv';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { ApplicationSettingsService } from 'src/app/services/application-settings.service';
import { Precision } from 'src/app/application-settings/components/general/general.component';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit, OnDestroy {
  @ViewChild('reportTab') private reportTab: ElementRef<HTMLElement>;
  routeId: number;
  displayCurrency: CurrencyState;
  route$: Observable<RouteState>;
  precision$: Observable<number>;
  showWarningReport: boolean;
  shouldPrintAllReports = false;
  isStandardUser: boolean;
  isEuRegion: boolean;
  checkDataVersion$: Observable<boolean>;
  private sm = new SubscriptionManager();
  constructor(
    private routeService: RouteService,
    private bsModalRef: BsModalRef,
    private userService: UserService,
    private appSettingsService: ApplicationSettingsService
  ) {
    this.resetPrintAll = this.resetPrintAll.bind(this);
    this.isStandardUser =
      this.userService.getUser()?.subscriptionLevel ===
      SubscriptionLevel.STANDARD;
    this.isEuRegion =
      this.userService.getUser()?.region.toLowerCase() === Common.Region.EU;
  }

  ngOnInit() {
    this.precision$ = this.appSettingsService.searchView$.pipe(
      map((searchOption) =>
        searchOption?.precision ? searchOption.precision : Precision.Hundredths
      )
    );
    this.route$ = this.routeService.routesState$.pipe(
      mergeMap((routeList) =>
        routeList.filter((route) => route.id === this.routeId)
      )
    );
    this.checkDataVersion$ = this.route$.pipe(
      map((route) => {
        const historicalDataVersion: boolean =
          this.routeService.checkHistoricalDataVersion(
            route.historicalDataVersion
          );
        return historicalDataVersion;
      })
    );

    window.addEventListener('beforeprint', this.resetPrintAll);
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeprint', this.resetPrintAll);
    this.sm.unsubscribe();
  }

  printAllReports() {
    this.shouldPrintAllReports = true;
    // TODO clean up
    setTimeout(() => {
      this.printReport();
    }, 100);
  }

  printReport() {
    window.print();
  }

  close() {
    this.bsModalRef.hide();
  }

  // reset the property whenever the print dialog is closed
  private resetPrintAll() {
    this.shouldPrintAllReports = false;
  }
  downloadCSV() {
    const reportTabElement = this.reportTab.nativeElement;
    for (let i = 0; i < reportTabElement.children.length; i++) {
      if (reportTabElement.children[i].classList.contains('active')) {
        const report: NodeListOf<HTMLTableElement> =
          reportTabElement.children[i].querySelectorAll('table');
        downloadCSV(report, `${reportTabElement.children[i].id}.csv`);
      }
    }
  }
}
